import { render, staticRenderFns } from "./LdmtApprovalStatus.vue?vue&type=template&id=5847540c"
import script from "./LdmtApprovalStatus.vue?vue&type=script&lang=js"
export * from "./LdmtApprovalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports